import dayjs, { Dayjs } from 'dayjs';
import {
  DateInfo,
  FilterType,
  MarketProduct,
  MarketSellerInfo,
  MarketType,
  PaginationOption,
  RefetchType,
} from 'generated/graphql';
import { DEFAULT_PAGE_SIZE } from './constants';

export const findAvailability = (availability: DateInfo[] | undefined, date: Dayjs) => {
  return availability?.find((availability: DateInfo) => dayjs(availability.date).isSame(date, 'day')) ?? null;
};

export interface SelectedFilterChip {
  id: string;
  label: string;
  type: FilterType;
}
export const DEFAULT_PAGINATION_OPTION: PaginationOption = {
  pageNumber: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  ids: [],
  type: RefetchType.Unknown,
};

export const DEFAULT_QUOTE_ID = '0';
